export default "__VITE_ASSET__Bdc5gkqL__"